import {Directive, HostBinding} from '@angular/core';
import {MAX_LENGTH} from '@npck/libs/commons';

@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: 'input[matInput]:not([maxlength])',
    standalone: true,
})
export class DefaultMaxLengthDirective {
    @HostBinding('attr.maxlength') maxlength = MAX_LENGTH;
}
